import React from "react";
import Richtext from "@dip/helsecore/src/components/shared/Wrappers/Richtext";
import type { FactBoxProps, BgColorOptions } from "./FactBox.d";

export function FactBox(props: Readonly<FactBoxProps>) {
  const {
    selectedBgColor,
    text
  } = props;

  const colorClassMap: Record<BgColorOptions, string> = {
    highlighted: 'bg-surface-neutral-subtle-02',
    neutral: 'bg-surface-neutral-grey'
  };

  const bgColor = colorClassMap[selectedBgColor];

  if (!text) return null;

  return (
    <section
      className={[
        bgColor,
        'border-0',
        'rounded-none',
        'p-lg',
        '[&>*:first-child]:pt-0',
        '[&>*:last-child]:pb-0',
      ]
        .join(' ')}
    >
      <Richtext className="enonicText factBox" text={text} />
    </section>
  );
}
